var calendarWidth = 175;
var calendarHeight = 143;
var calendar = null;
var weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
var errorP = null; //USED TO OUTPUT ERROR MESSAGE

//START - OPEN CALENDAR POPUP
function showCalendar(id, montharrival, dayarrival, returnmonth, returnday) {
    var title;
    var defaultDateString;
    var minDateString;
    var maxDateString;
    var minDate;
    var maxDate;

    switch (id) {
        case 0:
            title = 'Departing';
            defaultDateString = getElement(montharrival).value + '-' + getElement(dayarrival).value;
            minDate = getDateFromIsoDateString(defaultDateString);
            break;
        case 1:
            title = 'Returning';
            defaultDateString = getElement(returnmonth).value + '-' + getElement(returnday).value;
            minDate = getDateFromIsoDateString(getElement(montharrival).value + '-' + getElement(dayarrival).value);
            break;
    }

    minDateString = getIsoDateStringFromDate(minDate);

    maxDate = minDate;
    maxDate.setFullYear(maxDate.getFullYear() + 1);
    maxDateString = getIsoDateStringFromDate(maxDate);

    openCalendar(id, title, defaultDateString, minDateString, maxDateString, montharrival, dayarrival, returnmonth, returnday);
}
//END - OPEN CALENDAR POPUP

function closeCalendar() {
    if (calendar !== null) {
        calendar.close();
        calendar = null;
    }
}

function openCalendar(id, title, defaultDateString, minDateString, maxDateString, monArr, dayArr, monRet, dayRet) {
    var centreParentX;
    var centreParentY;
    var windowX;
    var windowY;

    // DATE STRINGS SHOULD BE IN THE ISO STANDARD FORMAT I.E. YYYY-MM-DD

    closeCalendar();

    if (isNaN(window.screenLeft)) {
        // NETSCAPE, MOZILLA
        centreParentX = window.screenX + (window.outerWidth / 2);
        centreParentY = window.screenY + (window.outerHeight / 2);
    }
    else {
        // IE
        centreParentX = window.screenLeft + (document.body.clientWidth / 2);
        centreParentY = window.screenTop + (document.body.clientHeight / 2);
    }

    windowX = centreParentX - (calendarWidth / 2);
    windowY = centreParentY - (calendarHeight / 2);

    calendar = window.open('/utility/calendar.aspx?id=' + id + '&title=' + title + '&defaultdate=' + defaultDateString + '&mindate=' + minDateString + '&maxdate=' + maxDateString + '&monArr=' + monArr + '&dayArr=' + dayArr + '&monRet=' + monRet + '&dayRet=' + dayRet, '_blank', 'toolbar=no,menubar=no,location=no,scrollbars=no,status=no,screenX=' + windowX + ',screenY=' + windowY + ',left=' + windowX + ',top=' + windowY + ',width=' + calendarWidth + ',height=' + calendarHeight + ',resizable=no');
}

function dateSelected(id, dateString, monArr, dayArr, monRet, dayRet) {
    switch (id) {
        case 0:
            findValueInList(getElement(dayArr), dateString.substr(8, 2));
            findValueInList(getElement(monArr), dateString.substr(0, 7));
            setReturnDate(dayArr, monArr, dayRet, monRet);
            break;
        case 1:
            findValueInList(getElement(dayRet), dateString.substr(8, 2));
            findValueInList(getElement(monRet), dateString.substr(0, 7));
            setWeekDay(dayRet + '_weekday', dateString);
            break;
    }
}

function getElement(elementId) {
    if (document.getElementById) {
        return document.getElementById(elementId);
    }
    else {
        return document.all[elementId];
    }
}

function findValueInList(list, value) {
    if (list !== null) {
        for (var i = 0; i < list.options.length; i++) {
            if (list.options[i].value == value) {
                list.selectedIndex = i;
                break;
            }
        }
    }
}

function setReturnDate(leaveDayId, leaveMonthId, returnDayId, returnMonthId) {
    var leaveDate;
    var returnDate;
    var returnDateString;

    leaveDate = getDateFromIsoDateString(getElement(leaveMonthId).value + '-' + getElement(leaveDayId).value);

    returnDate = leaveDate;
    returnDate.setDate(returnDate.getDate() + 7);

    returnDateString = getIsoDateStringFromDate(returnDate);
    if (returnDayId.indexOf('hs_') == -1) {
        findValueInList(getElement(returnDayId), returnDateString.substr(8, 2));
        findValueInList(getElement(returnMonthId), returnDateString.substr(0, 7));
    }
    setWeekDay(leaveDayId + '_weekday', leaveDate);
    setWeekDay(returnDayId + '_weekday', returnDate);
}

function getDateFromIsoDateString(dateString) {
    var year;
    var month;
    var day;

    // DATE STRING SHOULD BE IN THE ISO STANDARD FORMAT I.E. YYYY-MM-DD

    year = parseInt(dateString.substr(0, 4));
    // USE parseFloat AS parseInt INTERPRETS '01' AS 0 INSTEAD OF 1
    month = parseFloat(dateString.substr(5, 2));
    day = parseFloat(dateString.substr(8, 2));

    return new Date(year, month - 1, day);
}

function getIsoDateStringFromDate(date) {
    var year;
    var month;
    var day;

    // FORMAT DATE IN THE ISO STANDARD FORMAT I.E. YYYY-MM-DD

    year = date.getFullYear().toString();

    month = (date.getMonth() + 1).toString();
    if (month.length == 1) {
        month = '0' + month;
    }

    day = date.getDate().toString();
    if (day.length == 1) {
        day = '0' + day;
    }

    return year + '-' + month + '-' + day;
}

function checkAllCarTypes() {
    var csform = document.getElementById('csform');
    var formLength = csform.getElementsByTagName('input').length;
    for (var i = 0; i <= formLength - 1; i++) {
        if (csform.getElementsByTagName('input')[i].type == 'checkbox') {
            csform.getElementsByTagName('input')[i].checked = true;
        }
    }
}

function setWeekDay(id, selectedDate) {
    var tempSelectedDate = null;
    if (getElement(id)) {
        try {
            tempSelectedDate = getDateFromIsoDateString(selectedDate);
        } catch (err) {
            tempSelectedDate = selectedDate;
        }
        getElement(id).innerHTML = weekDays[tempSelectedDate.getDay()];
    }
}

function todayAsString() {
    var today = new Date();
    return weekDays[today.getDay()].substring(0, 3);
}

function todayAsStringFromElement(day, monYear) {
    if (day.length > 0 && monYear.length > 0) {
        var year = monYear.substring(0, 4);
        var mon = monYear.substring(5) - 1;
        var myDate = new Date();
        myDate.setFullYear(year, mon, day);
        return weekDays[myDate.getDay()].substring(0, 3);
    }
}

function addOnLoadEvent(show, hide1, hide2, tab) {
    if (window.addEventListener) {
        // W3C method
        window.addEventListener('load', toggleSearchBoxes(show, hide1, hide2, tab), false);
    }
    else if (window.attachEvent) {
        // IE method
        window.attachEvent('onload', toggleSearchBoxes(show, hide1, hide2, tab));
    }
}

function validateHotelLocation(inputId) {
    alert(getElement(inputId).selectedIndex);
    return false;
}

function validateInputBox(inputId, departDate, returnDate) {
    
    var retVal = true;
    var errors = [];
    

    var flightSearchContainer = document.querySelector(".flightsearch-container");
    var inputElement = document.querySelector("#" + inputId);

    inputElement.addEventListener("focus", function () {
        flightSearchContainer.classList.remove("flightsearch-container--destination-error");
    });

    if (getElement(inputId)) {
        var elementType = getElement(inputId).tagName;
        var destError = false;
        switch(elementType){
            case 'SELECT':
                if (getElement(inputId).selectedIndex === 0) {
                    destError = true;
                }
                break;  
            case 'INPUT':
                if (getElement(inputId).value.trim().length === 0 || getElement(inputId).value === "Destination") {
                    destError = true;
                }
                break;
        }
        if (destError) {
            errors.push("Please ensure that you have chosen a location");            
            retVal = false;

            flightSearchContainer.classList.add("flightsearch-container--destination-error");
            flightSearchContainer.classList.add("flightsearch-container--had-destination-error");            
        }
    }
    if (getElement(departDate)) {
        var today = new Date();
        var fromDate = {};
        if (getElement(departDate).value.trim().length === 10) {           
            today = getDateFromIsoDateString(convertToTenDigitDateString(today.getFullYear(), today.getMonth() + 1, today.getDate()));
            fromDate = new Date(getElement(departDate).value.substr(6, 4), getElement(departDate).value.substr(3, 2) - 1, getElement(departDate).value.substr(0, 2));
            if (fromDate < today) {
                //CHECK THAT THE START DATE IS IN THE FUTURE
                errors.push("Please ensure that the start date for your search is in the future");
                retVal = false;
            } else if (fromDate.getDate() != parseFloat(getElement(departDate).value.substr(0, 2)) || fromDate.getMonth() + 1 != parseFloat(getElement(departDate).value.substr(3, 2)) || fromDate.getFullYear() != parseInt(getElement(departDate).value.substr(6, 4))) {
                //CHECK THAT THE DATE IS VALID. IF YOU ATTEMPT TO PARSE AN IMPOSSIBLE DATE IN JAVASCRIPT RATHER THAN
                //ERRORING IT SIMPLY ROLLS THE DAYS OVER TO THE NEXT MONTH i.e. new Date(2010,02-1,29) RETURNS 1ST MARCH
                errors.push("Please ensure that the start date does not fall on an invalid date i.e. 30th Feb");
                retVal = false;
            }
        } else { 
            errors.push("Please enter a start date");
            retVal = false;
        }
        if (getElement(returnDate)) {
            if (getElement(returnDate).value.trim().length === 10) {
                var toDate = new Date(getElement(returnDate).value.substr(6, 4), getElement(returnDate).value.substr(3, 2) - 1, getElement(returnDate).value.substr(0, 2));
                if (toDate < today) {
                    //CHECK THAT THE END DATE IS IN THE FUTURE
                    errors.push("Please ensure that the end date for your search is in the future");
                    retVal = false;
                } else if (toDate < fromDate) {
                    //CHECK THAT THE END DATE IS AFTER THE START DATE
                    errors.push("Please ensure that the end date for your search is after the start date");
                    retVal = false;
                } else if (toDate.getDate() != parseFloat(getElement(returnDate).value.substr(0, 2)) || toDate.getMonth() + 1 != parseFloat(getElement(returnDate).value.substr(3, 2)) || toDate.getFullYear() != parseInt(getElement(returnDate).value.substr(6, 4))) {
                    //CHECK THAT THE DATE IS VALID. IF YOU ATTEMPT TO PARSE AN IMPOSSIBLE DATE IN JAVASCRIPT RATHER THAN
                    //ERRORING IT SIMPLY ROLLS THE DAYS OVER TO THE NEXT MONTH i.e. new Date(2010,02-1,29) RETURNS 1ST MARCH
                    errors.push("Please ensure that the end date does not fall on an invalid date i.e. 30th Feb");
                    retVal = false;
                }
            } else {
                errors.push("Please enter an end date");
                retVal = false;
            }
            
        }
    }
    if (inputId == 'locationnodeid') {
        var locationNodeId;
        if (getElement('locationnodeid') && parseInt(getElement('locationnodeid').value, 10) > 0) {
            locationNodeId = getElement('locationnodeid').value;            
            var that = true;
            var locationValidationAjaxObj = createAjaxObj();
            locationValidationAjaxObj.onreadystatechange = function () {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        if (this.responseText) {
                            locationValidation = JSON.parse(this.responseText);
                            if (locationValidation.IsValidSearchLocation === false) {
                                that = false;
                                errors.push("The area you have searched for is too big. Please be more specific with your search.");
                                if (getElement('fsdestinationcountry')) {
                                    getElement('fsdestinationcountry').style.color = 'red';
                                }
                            }
                        }
                    }
                }
            };
            locationValidationAjaxObj.open('GET', '/utility/validatehotellocation.aspx?locationnodeid=' + locationNodeId, false);
            locationValidationAjaxObj.send('');
            retVal = that;
        }
    }

    if (errors.length > 0) {
        var errorString = '';
        for (var i = 0; i < errors.length; i++) {
            errorString += errors[i] + '<br />';
        }
        if (getElement('erroroutput')) {
            if (errorP !== null) {
                errorP.parentNode.removeChild(errorP);
            }
            errorP = document.createElement('p');
            errorP.innerHTML = '';
            errorP.innerHTML = errorString;
            getElement('erroroutput').appendChild(errorP);
            getElement('erroroutput').style.visibility = 'visible';
            if (getElement('ctl00_topHorizontalContentHolder')) {
                getElement('ctl00_topHorizontalContentHolder').style.minHeight = 560 + 'px';
            }
        }
    }
    
    return retVal;
}

if (window.addEventListener) {														//EXECUTED ON WINDOW LOAD/UNLOAD EVENT. ATTEMPTS FF/MOZ ETC THEN IE THEN OVERIDES window.onload/unload EVENTS
    window.addEventListener('load', function() { showErrorMessageForSATB(); }, false);
} else if (window.attachEvent) {
    window.attachEvent('onload', showErrorMessageForSATB);
} else {
    window.onload = function() { showErrorMessageForSATB(); };
}

function showErrorMessageForSATB() {
    if (window.location.search.indexOf('satb=true') > -1) {
        if ($('.fullscreen-loader')) {
            $('.fullscreen-loader').delay(1000).fadeOut();
        }
        manuallyShowError("The area you have searched for is too big. Please be more specific with your search.");
        if (getElement('fsdestinationcountry')) {
            getElement('fsdestinationcountry').style.color = 'red';
        }
    } else if (window.location.search.indexOf('inon=true') > -1) {
        if ($('.fullscreen-loader')) {
            $('.fullscreen-loader').delay(1000).fadeOut();
        }
        manuallyShowError("An invalid number of nights has been entered");
    } else if (window.location.search.indexOf('slnr=true') > -1) {
        if ($('.fullscreen-loader')) {
            $('.fullscreen-loader').delay(1000).fadeOut();
        }
        manuallyShowError("The location you search for was not recognised. Please try again.");
    }
}

function manuallyShowError(msg) {    
    if (getElement('erroroutput')) {
        if (errorP !== null) {
            errorP.parentNode.removeChild(errorP); 
        }
        errorP = document.createElement('p');
        errorP.innerHTML = '';
        errorP.innerHTML = msg;
        getElement('erroroutput').appendChild(errorP);
        getElement('erroroutput').style.visibility = 'visible';
        if (getElement('ctl00_topHorizontalContentHolder')) {
            getElement('ctl00_topHorizontalContentHolder').style.minHeight = 560 + 'px';
        }
    }
}

function hideError(id) {
    if (id) {
        if (getElement(id)) {
            getElement('fsform').removeChild(getElement(id));
        }
    } else {
        if (getElement('erroroutput')) {
            errorP.innerHTML = "";
            getElement('erroroutput').style.visibility = 'hidden';
        }
    }
}

function convertToTenDigitDateString(fullYear, month, day) {
    if (day.toString().length == 1) {
        day = '0' + day;
    }
    if (month.toString().length == 1) {
        month = '0' + month;
    }
    return fullYear + '-' + month + '-' + day;
}

String.prototype.trim = function () {
    return this.replace(/^\s*|\s*$/g, '');
};

function createAjaxObj() {
    if (window.XMLHttpRequest) {
        return new XMLHttpRequest();
    } else if (window.ActiveXObject) {
        return new ActiveXObject('Microsoft.XMLHTTP');
    } else {
        return;
    }
}

function checkForMultipleLocations(locationNameInputId, showVariant) {

    var oneLocation = true;
    var locationName;
    var multipleLocations;
    var formHolder = getElement('fsform');
    var formActionIndexOf;
    var goToUrl = '';
    var queryStrParams = [];
    var currentDestinationNodeId = 0;
    var overrideGoToUrl = '';

    formActionIndexOf = formHolder.action.indexOf('?url=');

    if (formActionIndexOf != -1) {
        goToUrl = formHolder.action.substring(formActionIndexOf + 5, formHolder.action.length);
    }

    if (getElement('currentdestinationnodeid') && parseInt(getElement('currentdestinationnodeid').value, 10) !== 0) {
        //IF WE HAVE A LOCATION NODE ID SET IN PAGE CHECK IT AGAINST THE NODE IDS RETURNED FROM checkformultiplelocations.aspx
        currentDestinationNodeId = parseInt(getElement('currentdestinationnodeid').value, 10);
    }

    if (validateInputBox('flightsearchdestination', 'fsdepart', 'fsreturn')) {

        var destination, destinationId, currentDestination, originnodeid, fromDate, toDate, displayringaroundnumberonsubmit, fssubmit, flightClass;

        if (getElement(locationNameInputId) && getElement(locationNameInputId).value.trim().length > 0 && getElement('flightsearchdestinationid').value === 0) {
            locationName = getElement(locationNameInputId).value.trim();
            if (locationName.length > 0) {
                jQuery.ajax({
                    url: '/utility/checkformultiplelocations.aspx?locationname=' + locationName,
                    cache: false,
                    error: function (msg) { throw msg; },
                    parseJSON: function (multipleLocations) {
                        if (typeof multipleLocations !== "string" || !multipleLocations) {
                            return null;
                        }
                        multipleLocations = jQuery.trim(multipleLocations);
                        if (/^[\],:{}\s]*$/.test(data.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@")
                        .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]")
                        .replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) {
                            return window.JSON && window.JSON.parse ?
                            window.JSON.parse(multipleLocations) :
                            (new Function("return " + multipleLocations))(); //jshint ignore:line
                        } else {
                            jQuery.error("Invalid JSON: " + multipleLocations);
                        }
                    },
                    success: function (multipleLocations) {

                        if (multipleLocations.HasMultipleLocations) {
                            if (multipleLocations.Locations.length > 0) {

                                if (formHolder) {

                                    //I'M KEEPING THIS SWICH CASE FOR THE TIME BEING AS A FAIL OVER IN CASE WE DON'T HAVE A GOTOURL 
                                    if (goToUrl === '') {
                                        switch (formHolder.action) {
                                            case 'http://www.dialaflight.com/businesstravel/duplicatelocationsearch.aspx':
                                                goToUrl = '/businesstravel/searchresults.aspx';
                                                break;
                                            case 'http://localhost:50761/businesstravel/duplicatelocationsearch.aspx':
                                                goToUrl = '/businesstravel/searchresults.aspx';
                                                break;
                                            case '/businesstravel/duplicatelocationsearch.aspx':
                                                goToUrl = '/businesstravel/searchresults.aspx';
                                                break;
                                            default:
                                                goToUrl = '/flights/searchresults.aspx';
                                        }
                                    }

                                    //*IMPORTANT*//
                                    //THE BELOW SHOLD BE EASIER TO READ AND EASIER TO USE//
                                    //WHEN YOU ADD A PARAMETER TO MULTISEARCH THAT NEEDS TO BE REFERENCED ADD IT TO THE SWITCH CASE AND THE queryStrParams BELOW.  
                                    //IT WILL THEN BUILD THE URL IT NEEDS TO POINT TO                                     

                                    for (var i = 0; i < formHolder.length - 1; i++) {
                                        if (formHolder[i].id !== "") {
                                            switch (formHolder[i].id) {                                                
                                                case "flightsearchdestination":
                                                    destination = formHolder[i].value;
                                                    break;
                                                case "flightsearchdestinationid":
                                                    destinationId = formHolder[i].value;
                                                    break;
                                                case "currentdestination":
                                                    currentDestination = formHolder[i].value;
                                                    break;
                                                case "originnodeid":
                                                    originnodeid = formHolder[i].value;
                                                    break;
                                                case "fsdepart":
                                                    fromDate = formHolder[i].value;
                                                    break;
                                                case "fsreturn":
                                                    toDate = formHolder[i].value;
                                                    break;
                                                case "displayringaroundnumberonsubmit":
                                                    displayringaroundnumberonsubmit = formHolder[i].value;
                                                    break;
                                                case "ctl00_middleContent_multiSearch_fssubmit":
                                                    fssubmit = getElement('ctl00_middleContent_multiSearch_fssubmit');
                                                    break;
                                                case "fscabin":
                                                    flightClass = formHolder[i].value;
                                                    break;
                                            }
                                        }

                                    }

                                    var jsstatus = getElement('jsstatus').value;

                                    queryStrParams[0] = "?searchtype=flights";
                                    queryStrParams[1] = "&class=";
                                    queryStrParams[2] = "&originnodeid=" + originnodeid;
                                    queryStrParams[3] = "&flightsearchdestination=" + destination;
                                    queryStrParams[4] = "&fsdepart=" + fromDate;
                                    queryStrParams[5] = "&fsreturn=" + toDate;
                                    queryStrParams[6] = "&currentdestination=" + currentDestination;
                                    queryStrParams[7] = "&fscabin=" + flightClass;
                                    queryStrParams[8] = "&displayringaroundnumberonsubmit=" + displayringaroundnumberonsubmit;
                                    queryStrParams[9] = "&jsstatus=" + jsstatus;

                                    for (var j = 0; j < queryStrParams.length; j++) {
                                        goToUrl += queryStrParams[j];
                                    }

                                }

                                var multilocationsHolder = document.createElement('div');
                                multilocationsHolder.className = 'selectdestination';
                                multilocationsHolder.id = 'selectdestination';

                                var destinationAirportText = document.createElement('p');
                                var closelink = document.createElement('a');
                                var closeIcon = document.createElement('img');

                                closeIcon.src = '/images/structure/closeicon.gif';
                                closeIcon.width = 15;
                                closeIcon.height = 15;
                                closeIcon.alt = 'close';

                                closelink.href = 'javascript:hideError("selectdestination");';

                                destinationAirportText.innerHTML = 'We found more than one match for ' + destination + '. <br /> Please choose your destination:';

                                closelink.appendChild(closeIcon);
                                multilocationsHolder.appendChild(closelink);
                                multilocationsHolder.appendChild(destinationAirportText);

                                for (var a = 0; a < multipleLocations.Locations.length; a++) {
                                    var otherAirports = document.createElement('a');

                                    otherAirports.href = goToUrl + '&flightsearchdestinationid=' + multipleLocations.Locations[a].NodeId;

                                    otherAirports.innerHTML = multipleLocations.Locations[a].FullLocationName + '<br />';

                                    multilocationsHolder.appendChild(otherAirports);

                                    if (parseInt(multipleLocations.Locations[a].NodeId, 10) === currentDestinationNodeId) {
                                        overrideGoToUrl = goToUrl;
                                        break;
                                    }
                                }

                                if (overrideGoToUrl.length > 0) {
                                    if (showVariant) {
                                        getElement('fsform').action = '/flights/searchresults.aspx?showvariant=true&';
                                    } else {
                                        getElement('fsform').action = '/flights/searchresults.aspx';
                                    }                               
                                    getElement('fsform').submit();
                                } else {
                                    document.getElementById('fsform').appendChild(multilocationsHolder);
                                }
                            }
                        } else {
                            //CHANGE THE SUBMIT URL AS WE NO LONGER NEED TO GO VIA THE duplicatelocationsearch.aspx PAGE
                            if (getElement('keyPressEnter').value == 'N') {
                                if (showVariant) {
                                    getElement('fsform').action = '/flights/searchresults.aspx?showvariant=true&';
                                } else {
                                    getElement('fsform').action = '/flights/searchresults.aspx';
                                }
                                getElement('fsform').submit();
                            }
                        }
                    }
                });
            }
        } else {
            //CHANGE THE SUBMIT URL AS WE NO LONGER NEED TO GO VIA THE duplicatelocationsearch.aspx PAGE
            if (getElement('keyPressEnter').value == 'N' || !$('#fsdepart')) {
                if (showVariant) {
                    getElement('fsform').action = '/flights/searchresults.aspx?showvariant=true&';
                } else {
                    getElement('fsform').action = '/flights/searchresults.aspx';
                }
                getElement('fsform').submit();
            }
        }       
    }
}

function displayHotelSearch(bedsLocationNodeid, name) {

    var searchcontainer = document.getElementById("hiddenhotelsearchcontainer");
    var locationName = document.getElementById("bedslocationtext");
    var locationNodeId = document.getElementById("locationnodeid");
    var searchdestination = document.getElementById("searchdestination");
    var hotelsearchinfoholder = document.getElementById("hotelsearchinfoholder");

    if (searchdestination) {
        searchdestination.innerHTML = name + " ";
        if (hotelsearchinfoholder) {
            hotelsearchinfoholder.style.display = 'block';
        }
    }

    if (locationName) {
        locationName.value = name;
    }

    if (locationNodeId && bedsLocationNodeid > 0) {
        locationNodeId.value = bedsLocationNodeid;
    }
}

$(document).ready(function () {
    //CheckURLForVariant();
    AnimateBirdSprite();
});

var _webnodeid, _phoneA, _phoneB;

function setVariantWebNodeId(a) { _webnodeid = a; }
function setVariantPhoneA(a) { _phoneA = a; }
function setVariantPhoneB(a) { _phoneB = a; }

function CheckURLForVariant() {
    //CHECK IF ORLANDO
    if (_webnodeid === 1098) {
        var url = window.location.href;
        var _interval;

        if (url.indexOf("showvariant=true") > 0) {
            $('.special-offer-fares__image').animate({ opacity: 1 }, 300);
            $('.special-offer-fares__text').css({ opacity: 0 }).delay(3000).animate({ opacity: 1 }, 300, function () {
                $('.special-offer-fares__image').animate({ opacity: 0 }, 300, function () {
                    $('.special-offer-fares__image').css({ display: 'none' });
                    clearInterval(_interval);
                });
            });

            _interval = setInterval(function () {
                $('.humming-bird-sprite').toggleClass('active');
            }, 94);

            $('.foreground-content .telnumber').text(_phoneB);
        } else {
            $('.foreground-content .telnumber').text(_phoneA);
            $('.fullscreen-loader .telnumber').text(_phoneA);
        }
    }
}

function AnimateBirdSprite() {
    var url = window.location.href;
    var _interval;


        $('.special-offer-fares__image').animate({ opacity: 1 }, 300);
        $('.special-offer-fares__text').css({ opacity: 0 }).delay(3000).animate({ opacity: 1 }, 300, function () {
            $('.special-offer-fares__image').animate({ opacity: 0 }, 300, function () {
                $('.special-offer-fares__image').css({ display: 'none' });
                clearInterval(_interval);
            });
        });

        _interval = setInterval(function () {
            $('.humming-bird-sprite').toggleClass('active');
        }, 94);
}